"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var CreateBaseCategory = /** @class */ (function () {
    function CreateBaseCategory() {
        this.name = '';
    }
    __decorate([
        mobx_1.observable
    ], CreateBaseCategory.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], CreateBaseCategory.prototype, "name", void 0);
    __decorate([
        mobx_1.observable
    ], CreateBaseCategory.prototype, "colorHex", void 0);
    __decorate([
        mobx_1.observable
    ], CreateBaseCategory.prototype, "complianceCategoryId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateBaseCategory.prototype, "wooCommerceCategoryId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateBaseCategory.prototype, "leaflyCategory", void 0);
    __decorate([
        mobx_1.observable
    ], CreateBaseCategory.prototype, "categoryType", void 0);
    return CreateBaseCategory;
}());
exports.CreateBaseCategory = CreateBaseCategory;
var CreateCategory = /** @class */ (function (_super) {
    __extends(CreateCategory, _super);
    function CreateCategory() {
        var _this = _super.call(this) || this;
        _this.childCategories = [];
        mobx_1.observe(_this, function (change) {
            // All nested categories will have the same color as the parent
            if (['colorHex', 'complianceCategoryId'].includes(String(change.name))) {
                _this.childCategories.forEach(function (childCategory) {
                    childCategory[change.name] = (change.type === 'update' || change.type === 'add') && change.newValue;
                });
            }
        });
        return _this;
    }
    __decorate([
        mobx_1.observable
    ], CreateCategory.prototype, "childCategories", void 0);
    return CreateCategory;
}(CreateBaseCategory));
exports.CreateCategory = CreateCategory;
var ComplianceCategoryIdMapping;
(function (ComplianceCategoryIdMapping) {
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["SEED"] = 1] = "SEED";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["PLANTS"] = 2] = "PLANTS";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["DRIED"] = 3] = "DRIED";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["OIL"] = 4] = "OIL";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["FRESH_CANNABIS"] = 5] = "FRESH_CANNABIS";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["AGCO_ACCESSORY"] = 6] = "AGCO_ACCESSORY";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["EDIBLES_SOLIDS"] = 7] = "EDIBLES_SOLIDS";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["EDIBLES_NON_SOLIDS"] = 8] = "EDIBLES_NON_SOLIDS";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["EXTRACTS_INHALED"] = 9] = "EXTRACTS_INHALED";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["EXTRACTS_INGESTED"] = 10] = "EXTRACTS_INGESTED";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["EXTRACTS_OTHERS"] = 11] = "EXTRACTS_OTHERS";
    ComplianceCategoryIdMapping[ComplianceCategoryIdMapping["TOPICALS"] = 12] = "TOPICALS";
})(ComplianceCategoryIdMapping = exports.ComplianceCategoryIdMapping || (exports.ComplianceCategoryIdMapping = {}));
var CategoryType;
(function (CategoryType) {
    CategoryType["STANDARD"] = "standard";
    CategoryType["SYSTEM_FEES"] = "systemFees";
})(CategoryType = exports.CategoryType || (exports.CategoryType = {}));
//# sourceMappingURL=Category.js.map